<div class="general-info-card">
    <div class="medication-header">
        <div class="status-indicators">
            <span class="week-number">
                {{ averageWeight.weekName }}
            </span>
            <span class="increase-count">
                {{ averageWeight.targetDifference }}
            </span>
        </div>
        <div class="date-time">
            {{ averageWeight?.recordDate | date: 'yyyy-MM-dd' }} |
            {{ averageWeight?.recordDate | date: 'HH:mm' }}
        </div>
    </div>

    <div class="medication-grid">
        <div class="grid-item">
            <div class="field-label">Average Weight:</div>
            <div class="field-value">
                {{ averageWeight.averageWeight }} {{ weightUnit }}
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Weight Range:</div>
            <div class="field-value">{{ averageWeight.weightRange }}</div>
        </div>

        <div class="grid-item">
            <div class="field-label">Sample Size:</div>
            <div class="field-value">
                {{ averageWeight.sampleSize }} Bird(s)
            </div>
        </div>

        <div class="grid-item">
            <div class="field-label">Std Deviation:</div>
            <div class="field-value">{{ averageWeight.stdDeviation }}</div>
        </div>

        <div class="medication-notes">
            <div class="field-label">Notes:</div>
            <div class="field-value">{{ averageWeight?.notes || '-' }}</div>
        </div>
    </div>
</div>
